(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_a52345d"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function(event) {
  const button = event.target.closest('[data-tab], [data-dot], [data-dir]');
  if (!button) return;

  const root = button.closest('[data-tab-two-title]');
  if (!root) return;

  const current = Number(root.dataset.active || 0);
  const index = button.dataset.dir ? 1 - current : Number(button.dataset.tab ?? button.dataset.dot);
  root.dataset.active = index;

  root.querySelectorAll('[data-tab]').forEach((item) => {
    item.setAttribute('aria-selected', Number(item.dataset.tab) === index);
  });
  root.querySelectorAll('[data-dot]').forEach((item) => {
    item.setAttribute('aria-current', Number(item.dataset.dot) === index);
  });
  root.querySelectorAll('[data-panel]').forEach((item) => {
    item.hidden = Number(item.dataset.panel) !== index;
  });

  root.querySelector('[data-title]').textContent = index ? root.dataset.tabTwoTitle : root.dataset.tabOneTitle;
  root.querySelector('[data-text]').innerHTML = index ? root.dataset.tabTwoText : root.dataset.tabOneText;
});
  } catch(e) { console.error(e); }
})();

})();
